import type { ScreenData } from '../types';

/**
 * The `userFlow` that drives the bottom CTA's bank handoff. Resolves to the
 * first screen in the CVP payload that carries a `userFlow`. In practice the
 * HOME_SCREEN is that screen, so this returns its flow.
 */
export function resolveUserFlow(
	screens: ScreenData[] | null | undefined,
): string | null {
	if (!screens) return null;

	return screens.find((screen) => screen.userFlow)?.userFlow ?? null;
}
